import React from "react";

const Footer = () => {
    return <>
        <footer>
            <p>created by Yahia Mahmoud {new Date().getFullYear()}</p>
        </footer>
    </>
}

export default Footer;